export class DocumentLayoutInfo {
	public ID: number;
	public Name: string;
	constructor(data: any) {
		this.ID = data.ID;
		this.Name = data.Name;
	}
}
